import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useEmployee } from "~/providers/store/employee";
import { hasAttendedSellConfig } from "~/utils/tills/has-attended-sell-config";
import { useBasketContext } from "~/providers/store/basket/context";

export const usePathCleaner = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const isSkipReceipt = searchParams.get("skipReceipt") === "true";

  const isEmpty = useBasketContext((state) => state.isBasketEmpty);
  const { employeeChildId } = useEmployee();

  const { data: till } = useCurrentTill();

  if (!hasAttendedSellConfig(till) && till?.type !== "self-service") {
    throw new Error(
      "This hook is only supported for attended and self-service tills"
    );
  }

  // If skip receipt page is enabled, delete the orderId from the search params
  useEffect(() => {
    if (
      till.config.skipReceiptPage &&
      isSkipReceipt &&
      (!isEmpty || employeeChildId) &&
      orderId
    ) {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete("orderId");
        newParams.delete("skipReceipt");
        return newParams;
      });
    }
  }, [isEmpty, orderId, till, employeeChildId, setSearchParams, isSkipReceipt]);
};
